import {
	createContext,
	useContext,
	useState,
	useEffect,
	ReactNode,
} from 'react';
import { getEntity } from '@/utils/handleToken';

interface AttendanceFilterContextType {
	selectedMonth: number;
	selectedYear: number;
	selectedEntity: number | null;
	selectedCustomer: number | null;
	startDate: Date | null;
	endDate: Date | null;
	setSelectedMonth: (month: number) => void;
	setSelectedYear: (year: number) => void;
	setSelectedEntity: (entity: number | null) => void;
	setSelectedCustomer: (customer: number | null) => void;
	setStartDate: (date: Date | null) => void;
	setEndDate: (date: Date | null) => void;
}

const AttendanceFilterContext = createContext<
	AttendanceFilterContextType | undefined
>(undefined);

export function AttendanceFilterProvider({
	children,
}: {
	children: ReactNode;
}) {
	const [selectedMonth, setSelectedMonth] = useState<number>(
		new Date().getMonth() + 1
	);
	const [selectedYear, setSelectedYear] = useState<number>(
		new Date().getFullYear()
	);
	const [selectedEntity, setSelectedEntity] = useState<number | null>(null);
	const [selectedCustomer, setSelectedCustomer] = useState<number | null>(null);
	const [startDate, setStartDate] = useState<Date | null>(null);
	const [endDate, setEndDate] = useState<Date | null>(null);

	// Set entity otomatis jika hanya ada 1
	useEffect(() => {
		const entities = getEntity();
		if (entities.length === 1) {
			setSelectedEntity(entities[0] ?? 0);
		}
	}, []);

	return (
		<AttendanceFilterContext.Provider
			value={{
				selectedMonth,
				selectedYear,
				selectedEntity,
				selectedCustomer,
				startDate,
				endDate,
				setSelectedMonth,
				setSelectedYear,
				setSelectedEntity,
				setSelectedCustomer,
				setStartDate,
				setEndDate,
			}}
		>
			{children}
		</AttendanceFilterContext.Provider>
	);
}

export function useAttendanceFilter() {
	const context = useContext(AttendanceFilterContext);
	if (context === undefined) {
		throw new Error(
			'useAttendanceFilter must be used within an AttendanceFilterProvider'
		);
	}
	return context;
}
